import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../../_metronic/helpers'
import {User, UsersQueryResponse} from './_models'
import { Company } from '../../../company/company-list/core/_models'

const API_URL = process.env.REACT_APP_API_URL
const USER_URL = `${API_URL}/users`
const STATUS_UPDATE_URL = `${API_URL}/users/update-status`
const GET_USERS_URL = `${API_URL}/users`
const ADMIN_AUTH = `${API_URL}/admin/auth/update/password`
const USERS_URL = `${API_URL}/auth/create`
const USERS_URL_WITH_COMPANY = `${API_URL}/auth/createWithCompany`


const getUsers = (query: string,userid : string, companyid : string): Promise<UsersQueryResponse> => {
  return axios
    .get(`${GET_USERS_URL}?${query}&user_id=${userid}&company_id=${companyid}`)
    .then((d: AxiosResponse<UsersQueryResponse>) => d.data)
}

const getAllUsers = (): any => {
  return axios
    .get(`${GET_USERS_URL}/all`)
    .then((d: AxiosResponse<UsersQueryResponse>) => d.data)
}

const getUserById = (id: ID): Promise<User | undefined> => {
  return axios
    .get(`${USER_URL}/${id}`)
    .then((response: AxiosResponse<Response<User>>) => response.data)
    .then((response: Response<User>) => response.data)
}

const createUser = (user: User): Promise<User | undefined> => {
  return axios
    .post(USERS_URL, user)
    .then((response: AxiosResponse<Response<User>>) => response.data)
    .then((response: Response<User>) => response.data)
}

const updateUserDetail = (user: User): Promise<User | undefined> => {
  return axios
    .patch(`${GET_USERS_URL}/${user._id}`, user)
    .then((response: AxiosResponse<Response<User>>) => response.data)
    .then((response: Response<User>) => response.data)
}

const updateUser = (user: User): Promise<User | undefined> => {
  return axios
    .patch(`${STATUS_UPDATE_URL}/${user._id}`, user)
    .then((response: AxiosResponse<Response<User>>) => response.data)
    .then((response: Response<User>) => response.data)
}

const updatePassword = (user: User): Promise<User | undefined> => {
  
  return axios
    .post(`${ADMIN_AUTH}/${user._id}`, user)
    .then((response: AxiosResponse<Response<User>>) => response.data)
    .then((response: Response<User>) => response.data)
}

const deleteUser = (userId: ID): Promise<void> => {
  return axios.delete(`${USER_URL}/${userId}`).then(() => {})
}



const deleteSelectedUsers = (userIds: Array<ID>): Promise<void> => {
  const requests = userIds.map((id) => axios.delete(`${USER_URL}/${id}`))
  return axios.all(requests).then(() => {})
}


const createUserWithCompany = (user: any, company : any): Promise<User | undefined> => {
  user.company_id = company.company_id;
  user.company_name = company.company_name;
  return axios
    .post(USERS_URL_WITH_COMPANY, user)
    .then((response: AxiosResponse<Response<any>>) => response.data)
    .then((response: Response<any>) => response.data)
}

export {getUsers, deleteUser, deleteSelectedUsers, getUserById, createUser, updateUser,updateUserDetail,updatePassword,getAllUsers,createUserWithCompany}
